import React from 'react'

const Footer = () => {
  return (
    <>
    <div className='mx-auto w-full p-5 flex justify-center items-center border-t border-gray-300'>
        <p className='text-sm'>Copyright &copy; 2024 <span className='text-oceanBlue'>ZeroMiddleman</span> All Rights Reserved</p>
    </div>
    </>
  )
}

export default Footer